import { AllHTMLAttributes, DetailedHTMLProps, FC } from "react"
import styles from "./index.module.scss"


interface IProps extends DetailedHTMLProps<
    AllHTMLAttributes<HTMLDivElement>,
    HTMLDivElement
> {
    title: string
    noLine?: boolean
    mode?: "single" | "both"
}

const Title: FC<IProps> = ({ title, noLine, mode, ...rest }) => {
    return (
        <h4 {...rest} className={styles.title + ` ${noLine ? styles.no_line : ""} ${rest.className ? rest.className : ""} ${mode ? styles[mode] : ""}`}>
            {title}
        </h4>
    )
}

export default Title